import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { formatViews, getHot } from "@/lib/media";

export default function HotSection() {
  const hot = getHot(6);

  const rankRows = hot.map((item, index) => ({ item, rank: index + 1 }));

  return (
    <section className="py-10 md:py-14" aria-label="热门影视推荐">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-sm font-medium text-accent-400">
              <i className="ri-fire-line"></i>
              按播放热度排序
            </span>
            <h2 className="mt-1 font-heading text-xl font-bold text-foreground-50 md:text-3xl">热门影视推荐</h2>
            <p className="mt-2 text-sm text-foreground-400">观众点击与讨论度最高的影视作品</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3">
              {hot.map((item) => (
                <MediaCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside className="rounded-lg border border-background-800 bg-background-900/60 p-5" aria-label="热播榜">
            <h3 className="font-heading text-base font-semibold text-foreground-50">热播榜单</h3>
            <ul className="mt-4 space-y-1">
              {rankRows.map(({ item, rank }) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-800/70"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        rank <= 3 ? "bg-accent-500 text-background-950" : "bg-background-700 text-foreground-300"
                      }`}
                    >
                      {rank}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-100">{item.title}</span>
                      <span className="block truncate text-xs text-foreground-400">
                        {item.year} · {item.genres.slice(0, 2).join(" / ")}
                      </span>
                    </span>
                    <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-300">
                      <i className="ri-fire-line text-accent-400"></i>
                      {formatViews(item.views)}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}